<template>
  <div class="search-component">
    <div class="filter-collapse-btn">
      <div>
        <el-button
          v-if="searchShow"
          icon="el-icon-arrow-up"
          size="mini"
          @click="searchShow = false"
          >{{ $t('searchBox.hideFilterBtn') }}</el-button
        >
        <el-button
          v-else
          icon="el-icon-arrow-down"
          size="mini"
          @click="searchShow = true"
          >{{ $t('searchBox.showFilterBtn') }}</el-button
        >
      </div>
      <div v-if="searchShow" class="button-containers m-0 flex gap-10">
        <button class="btn primary small outline" @click="onReset">
          {{ $t('button.resetFilter') }}
        </button>
        <button class="btn primary small" @click="onSearch">
          {{ $t('button.search') }}
        </button>
      </div>
    </div>
    <el-collapse-transition>
      <div v-show="searchShow" class="filter_container">
        <div class="section-box">
          <slot></slot>
        </div>
        <hr v-if="!nonBorder" />
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
export default {
  props: {
    searchShow: {
      type: Boolean,
      default: false
    },
    nonBorder: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // searchShow: false
    }
  },
  methods: {
    onSearch() {
      this.$emit('onSearch')
    },
    onReset() {
      this.$emit('onReset')
    }
  }
}
</script>
